import type { ResolvedTeamPerformancePageRow } from "@repo/app-types/entities/teammatePerformanceSummary";
import type { FC } from "react";

export interface TeammateCallCountProps {
  row: ResolvedTeamPerformancePageRow;
}

export const TeammateCallCount: FC<TeammateCallCountProps> = (props) => {
  const { row } = props;
  if (row.recording_count === undefined) {
    return "--";
  }
  return row.recording_count.toLocaleString();
};
